import { StateCreator } from 'zustand';

export type EntityPendingChangesState = {
    revisionId: number | undefined;
};
export const initialEntityPendingChangesState: EntityPendingChangesState = {
    revisionId: 0
};

export interface EntityPendingChangesSlice {
    entityPendingChanges: EntityPendingChangesState;
    setEntityPendingChanges: (data: EntityPendingChangesState) => void;
}

export const createEntityPendingChangesSlice: StateCreator<
    EntityPendingChangesSlice,
    [],
    [],
    EntityPendingChangesSlice
> = (set) => ({
    entityPendingChanges: { ...initialEntityPendingChangesState },
    setEntityPendingChanges: (entityPendingChangesData: EntityPendingChangesState) =>
        set(() => ({ entityPendingChanges: entityPendingChangesData }))
});
